/* WALLTRAUD® compatibility quick check. Keeps product/cart state by using a native dialog. */
(() => {
  if (window.__wtFitCheckInitialized) return;
  window.__wtFitCheckInitialized = true;

  const root = document.querySelector('[data-wt-fit-check]');
  const dialog = root?.querySelector('dialog.wt-fit__dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const results = {
    plain: {
      title: 'Grundsätzlich geeignet für normale Wände',
      text: 'Du benötigst kein Lamellenraster. WALLTRAUD® Wandmöbel werden direkt in der Wand befestigt. Prüfe den Wanduntergrund und verwende dafür geeignete Dübel und Schrauben.',
      warning: false
    },
    '27-13': {
      title: 'Das Raster passt! ✓',
      text: '27 mm Lamelle + 13 mm Zwischenraum ergeben das passende 40-mm-Raster. Die vorgesehenen Bohrpunkte liegen genau mittig zwischen den Lamellen. Befestigt wird durch den Filz in der dahinterliegenden Wand.',
      warning: false
    },
    '25-15': {
      title: 'Das Raster passt! ✓',
      text: '25 mm Lamelle + 15 mm Zwischenraum ergeben das passende 40-mm-Raster. Die vorgesehenen Bohrpunkte liegen genau mittig zwischen den Lamellen. Befestigt wird durch den Filz in der dahinterliegenden Wand.',
      warning: false
    },
    other: {
      title: 'Anderes Raster? Bitte erst prüfen.',
      text: 'Bei abweichenden Maßen können wir die mittige Lage der Befestigungspunkte nicht zusichern. Kontaktiere uns vor der Bestellung oder lies die ausführlichen Kompatibilitätsinformationen.',
      warning: true
    },
    unknown: {
      title: 'Kein Problem – kurz nachmessen.',
      text: 'Miss von vorn die Breite einer Holzlamelle und den freien Filzstreifen bis zur nächsten Lamelle. 27/13 und 25/15 mm passen. Bei anderen Maßen helfen dir unsere ausführlichen Infos.',
      warning: true
    }
  };
  const panelStep = root.querySelector('[data-wt-fit-panel-step]');
  const resultBox = root.querySelector('[data-wt-fit-result]');
  const title = root.querySelector('[data-wt-fit-result-title]');
  const resultText = root.querySelector('[data-wt-fit-result-text]');
  let previousFocus = null;

  function showResult(key) {
    const data = results[key];
    if (!data) return;
    title.textContent = data.title;
    resultText.textContent = data.text;
    resultBox.classList.toggle('wt-fit__result--warning', !!data.warning);
    resultBox.querySelector('.wt-fit__result-icon').textContent = data.warning ? 'i' : '✓';
    resultBox.hidden = false;
  }
  function reset() {
    panelStep.hidden = true;
    resultBox.hidden = true;
    root.querySelectorAll('[aria-pressed]').forEach(node => node.setAttribute('aria-pressed', 'false'));
  }
  function closeDialog() { if (dialog.open) dialog.close(); }
  function openDialog(trigger) {
    if (dialog.open) return;
    previousFocus = trigger;
    reset();
    dialog.showModal();
    root.querySelector('[data-wt-fit-wall="plain"]')?.focus();
  }

  root.addEventListener('click', event => {
    const closeButton = event.target.closest('[data-wt-fit-close]');
    if (closeButton) { closeDialog(); return; }
    const wallButton = event.target.closest('[data-wt-fit-wall]');
    if (wallButton) {
      root.querySelectorAll('[data-wt-fit-wall]').forEach(b => b.setAttribute('aria-pressed', String(b === wallButton)));
      root.querySelectorAll('[data-wt-fit-raster]').forEach(b => b.setAttribute('aria-pressed', 'false'));
      const isPanel = wallButton.dataset.wtFitWall === 'panel';
      panelStep.hidden = !isPanel;
      resultBox.hidden = true;
      if (!isPanel) showResult('plain');
      return;
    }
    const rasterButton = event.target.closest('[data-wt-fit-raster]');
    if (rasterButton) {
      root.querySelectorAll('[data-wt-fit-raster]').forEach(b => b.setAttribute('aria-pressed', String(b === rasterButton)));
      showResult(rasterButton.dataset.wtFitRaster);
      // On narrow screens bring the answer into view inside the scrollable dialog.
      if (window.matchMedia('(max-width: 600px)').matches) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        resultBox.scrollIntoView({behavior: reduced ? 'instant' : 'smooth', block: 'nearest'});
      }
    }
  });

  dialog.addEventListener('click', event => { if (event.target === dialog) closeDialog(); });
  dialog.addEventListener('close', () => {
    if (previousFocus?.isConnected) previousFocus.focus({preventScroll: true});
    previousFocus = null;
  });

  // Preserve the existing internal destination as a fallback if JS is disabled.
  // Exclude the main navigation/footer and the full-info link inside this modal.
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest('a[href]');
    if (!anchor || anchor.closest('[data-wt-fit-check]')) return;
    if (anchor.closest('footer,nav,[role="navigation"],.shopify-section-group-header-group,.shopify-section-group-footer-group')) return;
    if (anchor.closest('header') && !anchor.closest('main,[role="main"],#MainContent')) return;
    if (anchor.hasAttribute('download') || (anchor.target && anchor.target !== '_self')) return;
    let targetUrl;
    try { targetUrl = new URL(anchor.href, window.location.href); } catch { return; }
    const isTrustedHost = targetUrl.origin === window.location.origin || ['walltraud.de', 'www.walltraud.de'].includes(targetUrl.hostname);
    if (!isTrustedHost) return;
    if (targetUrl.pathname.replace(/\/$/, '') !== '/pages/kompatibilitat-prufen') return;
    if (window.location.pathname.replace(/\/$/, '') === '/pages/kompatibilitat-prufen') return;
    event.preventDefault();
    openDialog(anchor);
  });
})();
